import React from "react";

const SystemRow = ({ system, i, orderHistory }) => {

  const count =
    orderHistory?.systemCountMap?.[system?.id] || 0;

  return (
    <div key={i}>
      <div className="breakdown-item">
        <span className="item-name">{system?.name}</span>
        <span className="item-count">{count}</span>
      </div>
    </div>
  );
};

export default SystemRow;